import React, { useState } from 'react';
import { auth, db } from '../settings/firebase';
import PageBody from '../components/PageBody';
import NoImg from '../img/noimg.jpg';
import PopupToShareUrl from '../components/PopupToShareUrl'
import './Page.css';

const cardContents = {
  docId: "test0",
  title: "",
  urlTitle: "",
  description: "",
  comment: "",
  image: [],
  recommender: "",
  avatarUrl: NoImg,
  thumbnail: NoImg,
}

class Page extends React.Component {
  constructor(props) {
    super(props);
    let urlParamStr = window.location.search.replace("?", "");
    let params = {}
    urlParamStr.split('&').forEach( param => {
      const temp = param.split('=')
      //pramsオブジェクトにパラメータを追加
      params = {
        ...params,
        [temp[0]]: temp[1]
      }
    })
    // console.log(params)
    let showPopup = false;
    let ptext = "このページを共有"
    if(params["status"] === "success") {
      showPopup = true;
      ptext = "投稿完了！"
    }
    this.state = {item: cardContents, editor: this.props.match.params.userid, bookid: "", pageid: this.props.match.params.pageid, showPopup: showPopup, popupText: ptext};
    this.componentDidMount = this.componentDidMount.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
  }

  _isMounted = false; //unmountを判断（ローディング判定用）

  // 最初に読み込むときに行う
  async componentDidMount() {
    let editorid = "";
    let usershot = [];
    await db.collection("users").get().then((snapshot) => {
      usershot = snapshot;
    })
    db.collection("displayids").doc(this.state.editor).onSnapshot((doc) => {
      if (doc.exists) {
        editorid = doc.data().uid;
        console.log("Recommender UID: "+editorid);
        // Firestoreからデータ一覧を取得する
        let articlesDb = db.collection("items");
        let data = {};
        console.log("PageID: "+this.state.pageid)
        articlesDb.doc(this.state.pageid).onSnapshot((doc) => {
          if (doc.exists) {
            data = doc.data();
            data.docId = doc.id;
            if(data.thumbnail.length === 0) {
              data.thumbnail = NoImg;
            }
            usershot.forEach(userdoc => {
              if(userdoc.id === data.recommender) {
                data.avatarUrl = userdoc.data().avatarUrl;
                data.username = userdoc.data().name;
                data.displayid = userdoc.data().displayid;
              }
            });
            this.setState({ item: data });
          } else {
            console.log("このページはありません");
          }
        })
      } else {
        console.log("このアカウントはありません");
      }
    });

    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  togglePopup() {
    this.setState({ showPopup: !this.state.showPopup, popupText: "このページを共有" });
  }

  render() {
    let item = this.state.item;
    return (
      <>
        <PageBody data={item} sharelink={this.togglePopup} />
        {this.state.showPopup ? 
          <PopupToShareUrl status={this.state.status} text={this.state.popupText}
            subtext="URLを共有して友達に教えましょう！" editor={this.state.editor}
            pid={this.state.pageid} closePopup={this.togglePopup.bind(this)} />
          : null
        }
      </>
    )
  }
}

export default Page